const url = process.env.VUE_APP_URL;

export { url };
